var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRecordIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.666 7.334a4.667 4.667 0 1 0-9.333 0V16a4.667 4.667 0 1 0 9.333 0V7.334z",
    stroke: "url(#cdzk47fsva)",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 15.334c0 5.523 4.477 10 10 10m0 0c5.523 0 10-4.477 10-10m-10 10v4",
    stroke: "url(#x4s50s2gcb)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cdzk47fsva",
    x1: 11.333,
    y1: 13.134,
    x2: 21.296,
    y2: 11.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x4s50s2gcb",
    x1: 6,
    y1: 23.475,
    x2: 24.038,
    y2: 15.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordIcon);
export default __webpack_public_path__ + "static/media/recordIcon.ee89e650a44e0d23a1a7083e5919c82e.svg";
export { ForwardRef as ReactComponent };